import { useDataValue } from 'Simple/Data.js'
import { toPostgresArray } from 'Data/format.js'

/** @type {import('Simple/types.js').useDataConfiguration} */
export default function useDataConfiguration(props) {
  let patient_id = useDataValue({
    viewPath: props.viewPath,
    context: 'appointment_overlay',
    path: 'patient_id',
  })

  return {
    variables: { patient_id, ignored_booking_ids: toPostgresArray([]) },
    pause: !patient_id,
  }
}
